import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { studentListres } from "../../../pages/main-pages/super-admin/students/list/StudentsList";

export interface Pagination {
  total: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export interface studentState {
  pagination: Pagination;
  students: studentListres[];
}

const initialState: studentState = {
  pagination: { total: 0, pageNumber: 1, pageSize: 15, totalPages: 1 },
  students: [],
};

const StudentsSliceReducer = createSlice({
  name: "Students",
  initialState,
  reducers: {
    setStudentListData(state, action: PayloadAction<studentState>) {
      state.students = action?.payload.students;
      state.pagination = action?.payload?.pagination;
    },
  },
});

export const { setStudentListData } = StudentsSliceReducer.actions;

export default StudentsSliceReducer.reducer;
